import Yup from '../../../../common/validator';
const getSchema = (patterns) => Yup.object({
    pattern: Yup.string()
        .label('Pattern')
        .required()
        .test('unique', '${path} already exists.', value => !patterns.map(v => v.split('=')[0]).includes(value)),
});
export default getSchema;
